import wx from 'weixin-js-sdk'

const WebViewEnv = {
  "WAP":'WAP',
  "IOS":'IOS',
  "Android":'Android',
  "miniprogram" :'miniprogram',
}

const PageEnv = {
  "IOS":'IOS',
  "Android":'Android',
}
export function getWebViewEnv(){
  let result = 'WAP'
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent)
  if (
    navigator.userAgent.includes('from=app') ||
    navigator.userAgent.includes('from=brokerapp')
  ) {
    result = isIOS ? WebViewEnv.IOS : WebViewEnv.Android
  } else {
    wx.miniProgram.getEnv(function (res) {
      if (res.miniprogram) {
        result = WebViewEnv.miniprogram
      }
    })
  }
  return result
}

// /**
//  * 上面异步返回的同步调用
//  */
export function getWebViewEnvSync(){
  let result = WebViewEnv.WAP
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent)
  if (
    navigator.userAgent.includes('from=app') ||
    navigator.userAgent.includes('from=brokerapp')
  ) {
    result = isIOS ? WebViewEnv.IOS : WebViewEnv.Android
    return result
  } else {
    if (navigator.userAgent.includes('miniProgram')) {
      result = WebViewEnv.miniprogram
      return result
    }
    return result
  }
}

/**
 * 上面异步返回的同步调用
 */
export function getPageFromIOSOrAndroid(){
  let result = PageEnv.Android
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent)
  if (isIOS) {
    result = PageEnv.IOS
  }
  return result
}

export function getUrlParams(){
  const url = window.location.href
  let theRequest = new Object()
  if (url.indexOf('?') != -1) {
    let str = url.split('?')[1]
    if (str.indexOf('&') != -1) {
      let strs = str.split('&')
        for (let i = 0; i < strs.length; i++) {
        theRequest[strs[i].split('=')[0]] = decodeURIComponent(
          strs[i].split('=')[1],
        )
      }
    }else {
      theRequest[str.split('=')[0]] = decodeURIComponent(str.split('=')[1])
    }
  }
  return theRequest
}    




